/* eslint-disable no-useless-concat */
import { Constants } from '@/utils/constants';
/**
 * 「MNP申込情報」の「申込状態」の表示用文字列を返却する。
 * @param status 申込状態コード
 * @returns 表示用文字列
 */
// eslint-disable-next-line import/prefer-default-export
export const getMnpApplicationStatus = (status: string) => {
  switch (status) {
    case Constants.MnpApplicationStatus.OPTION_UPDATE_PROCESSING:
      return 'オプション変更処理中';
    case Constants.MnpApplicationStatus.SHIPPING:
      return '商品発送済み';
    case Constants.MnpApplicationStatus.MNP_RESERVE_WAIT:
      return 'MNP転入予約待ち';
    case Constants.MnpApplicationStatus.MNP_RESERVING:
      return 'MNP転入予約中';
    default:
      return null;
  }
};
/**
 * 「MNP申込情報」の「解約受付状態」の表示用文字列を返却する。
 * @param status 解約受付状態コード
 * @returns 表示用文字列
 */
// eslint-disable-next-line import/prefer-default-export
export const getMnpQuitApplicationStatus = (status: string) => {
  switch (status) {
    case Constants.MnpQuitApplicationStatus.ACCEPT:
      return '解約受付';
    case Constants.MnpQuitApplicationStatus.WAIT_MNP_PORT_OUT_NUMBER:
      return 'MNP予約番号発番待ち';
    case Constants.MnpQuitApplicationStatus.WAIT_MNP_PORT_OUT:
      return 'MNP転出待ち';
    case Constants.MnpQuitApplicationStatus.END:
      return '解約完了';
    default:
      return null;
  }
};
// それぞれの音声通話プランの金額文字列を取得する
export const writeCallFlatPrice = (
  classType: string | undefined,
  callFlats: { [key: string]: number },
  callFlatExpiredText: string = ''
) => {
  if (classType)
    return `月額${callFlats[classType].toLocaleString()}円${
      callFlatExpiredText && `　${callFlatExpiredText}`
    }`;
  return '';
};

// それぞれの音声通話プランの金額を取得する
export const CallFlatPrice = (
  classType: string | undefined,
  callFlats: { [key: string]: number }
): number => {
  if (classType) return callFlats[classType];
  return 0;
};

// 通話定額プラン選択時、通話定額オプション料金を含む金額文字列を取得する
export const getTotalMonthlyRate = (
  classType: string | undefined,
  monthlyRate: number,
  callFlats: { [key: string]: number },
  selectCallFlatRatePlan: boolean
) => {
  const totalMonthlyRate = classType ? monthlyRate + callFlats[classType] : 0;
  if (selectCallFlatRatePlan) return totalMonthlyRate.toLocaleString();
  return monthlyRate.toLocaleString();
};

// 金額を3桁区切りの文字列に変換する
export const formatAmount = (value: number | string): string => {
  const amount = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(amount)) return '-';
  return amount.toLocaleString('ja-JP');
};

/**
 * サロゲートが存在するか確認(絵文字)
 * @param str 対象の文字
 * @return サロゲートペア発見:True,未発見:False
 */
export const hasSurrogatePair = (str: string): boolean => {
  const surrogatePairRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
  return surrogatePairRegex.test(str);
};
